import { setProducts } from "../store/slices/product-slice";
import appConfig from "../data/config";

/**
 * Thunk para obtener productos desde la API si es necesario.
 * Verifica si los productos ya están en el estado de Redux y si la caché ha expirado.
 */
export const fetchProductsIfNeeded = () => async (dispatch, getState) => {
  const state = getState();
  const { products, lastFetch } = state.product;
  const cacheDuration = appConfig.productCacheMinutes * 60 * 1000; // en milisegundos

  // Si no hay productos o si la caché ha expirado, realiza el fetch.
  if (products.length === 0 || !lastFetch || (Date.now() - lastFetch > cacheDuration)) {
    try {
      const response = await fetch(`${appConfig.apiUrl}/products`, {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('La respuesta de la red no fue correcta');
      }

      const data = await response.json();

      // Mapea los datos de la API al formato que espera la aplicación
      const formattedProducts = data.map(p => ({
        ...p,
        id: p.code, // Asumiendo que 'code' es el identificador único
        sku: p.code,
        price: parseFloat(p.price),
        discount: p.discount && parseFloat(p.discount) > 0 ? parseFloat(p.discount) : null,
        fullDescription: p.fullDescription && p.fullDescription.trim() ? p.fullDescription : null,
        new: !!p.new,
        category: JSON.parse(p.category || '[]'),
        quantityPerBox: p.quantityPerBox,
        tag: JSON.parse(p.tag || '[]'),
        image: (JSON.parse(p.image || '[]')).map(img => img.startsWith('http') ? img : `${appConfig.imageBaseUrl}/${img}`)
      }));

      // Despacha la acción para guardar los productos y la fecha de carga
      dispatch(setProducts(formattedProducts));

    } catch (error) {
      console.error("Fallo al obtener los productos:", error);
    }
  }
};
